import React from 'react';
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import GameData from "../../../gameplay/model/GameData";
import TenderCard from "./TenderCard";
import {CargoNames, CLIENT_NAMES, STATION_NAMES} from "../../../constants/Constants";
import TendersPlaceOrderPopup from "./TendersPlaceOrderPopup";
import ConfirmPopup from "../Popups/ConfirmPopup";
import TenderResearch from "./TenderResearch";
import agent from "../../../agent";
import UtilsFunctions from "../../../utils/UtilsFunctions";

class TendersPanel extends React.Component {
    constructor() {
        super();

        this.state = {
            isShowOrder: false,
            isShowResearch: false,
            isShowResearchConfirm: false,
            currentTender: {},
            orderData: {}
        };

        let clientsIndex = UtilsFunctions.getRoleNameIndex("Зам. по работе с клиентами");
        this.isClientMaster = UtilsFunctions.playerHasRole(clientsIndex);
        localStorage.removeItem("tenderResultsShown");
    }

    checkIfResearched(tender) {
        let allResearched = GameData.CurrentGame.tenders.filter(el => el.isMarketResearchBuyed);
        return allResearched.indexOf(tender) !== -1;
    }

    checkIfOrderPlaced(tender) {
        let allPlaced = GameData.CurrentGame.tenders.filter(el => el.isPlacedOrder);
        return allPlaced.indexOf(tender) !== -1;
    }

    onPlaceOrder(tender) {
        this.setState({
            isShowOrder: true,
            currentTender: tender
        });
    }

    handleResearchClick(tender) {
        this.setState({
            currentTender: tender
        });

        let tenders = GameData.CurrentGame.tenders.filter(el => el.isMarketResearchBuyed);

        if (tenders.indexOf(tender) !== -1) {
            this.onShowResearch();
        } else {
            this.onBuyResearch();
        }
    }

    onBuyResearch() {
        this.setState({
            isShowResearchConfirm: true,
        });
    }

    onShowResearch() {
        this.setState({
            isShowResearch: true
        });
    }

    onHideResearch() {
        this.setState({
            isShowResearch: false
        });
    }

    onHidePlaceOrder() {
        this.setState({
            isShowOrder: false
        })
    }

    onCancelResearch() {
        console.log("cancelled")

        this.setState({
            isShowResearchConfirm: false
        })
    }

    onOkResearch() {
        if (!this.isClientMaster) {
            alert("Проводить маркетинговые исследования может только Зам. по работе с клиентами");
            this.setState({
                isShowResearchConfirm: false
            })

            return;
        }

        agent.GamePlay.buyMarketingResearch(this.props.teamID, {tenderId: this.state.currentTender.id}, result => {
            console.log(result);
        });

        this.setState({
            isShowResearchConfirm: false,
            isShowResearch: true
        })
    }

    onOkOrder(orderData) {
        if (!this.isClientMaster) {
            alert("Подтверждать участие в тендерах может только Зам. по работе с клиентами");
            this.setState({
                isShowResearchConfirm: false
            })

            return;
        }

        let {tenderId, costPerTon, loadDay, unloadDay, nps, exp, credit} = orderData;
        credit = Math.abs(parseInt(credit) / 100) || 0.001;

        // Если у игрока опыта 0, то будет ошибка деления на ноль на бэке
        nps = parseInt(nps) === 0 ? 1 : parseInt(nps);
        exp = parseInt(exp) === 0 ? 1 : parseInt(exp);

        agent.GamePlay.tenderPlaceOrder(this.props.teamID, {
            tenderId: parseInt(tenderId),
            costPerTon: parseInt(costPerTon),
            loadDay: parseInt(loadDay),
            unloadDay: parseInt(unloadDay),
            nps: nps,
            exp: exp,
            credit: parseFloat(credit)
        }, result => {
            console.log(result);
        });

        this.setState({
            isShowOrder: false,
        })
    }

    onCancelOrder() {
        this.setState({
            isShowOrder: false
        })
    }

    render() {
        let tenders = GameData.CurrentGame.tenders;
        let content = [];
        if (tenders) {
            for (let i = 0; i < tenders.length; i++) {
                let tender = tenders[i];
                content.push(<TenderCard
                    index={i + 1}
                    key={i + 1}
                    code={tender.order.code}
                    client={CLIENT_NAMES[tender.order.client]}
                    from={STATION_NAMES[tender.order.fromId]}
                    to={STATION_NAMES[tender.order.toId]}
                    cargo={CargoNames[tender.order.trainCarType]}
                    weight={tender.order.weight}

                    onPlaceOrder={() => {
                        this.onPlaceOrder(tender)
                    }}
                    onBuyResearch={() => {
                        this.handleResearchClick(tender)
                    }}

                    isResearched={this.checkIfResearched(tender)}
                    isOrdered={this.checkIfOrderPlaced(tender)}
                />)
            }
        }
        let mainStyle = {
            padding: 10
        }
        let scrollStyle = {
            overflowY: "visible",
            overflowX: "hidden",
            height: "280px",
            marginRight: "10px"
        }
        let moveStyle = {
            position: "absolute",
            left: this.props.width / 2,
            top: this.props.height / 2,
            transform: "translate(-50%,-50%)"
        }
        content = <div style={{...mainStyle}}>
            <TenderCard
                index={0}
                key={0}
                code={"Код заказа"}
                client={"Клиент"}
                from={"Станция отпр"}
                to={"Станция назн"}
                cargo={"Груз"}
                weight={"Тоннаж"}
                costParticipate={"Стоимость участия - 3 000 000\n" +
                "Стоимость исследования - 3 000 000"}
                fontSize={8}
                fontWeight={"normal"}
            />
            <div style={scrollStyle}>
                {content}
            </div>
        </div>

        let confirmResearchPopup = <ConfirmPopup message={"<p>вы уверены, что хотите потратить <br/>3 миллиона на маркетинговое исследование?</p>"}
                                                 title={"Купить исследование"}
                                                 onCancel={this.onCancelResearch.bind(this)}
                                                 onOk={this.onOkResearch.bind(this)}/>;
        let showResearchPopup = <TenderResearch onHide={this.onHideResearch.bind(this)}
                                                tender={this.state.currentTender}/>;
        let orderPopup = <TendersPlaceOrderPopup
            isBought={this.checkIfOrderPlaced(this.state.currentTender)}
            onHide={this.onHidePlaceOrder.bind(this)} onOk={this.onOkOrder.bind(this)}
            onCancel={this.onCancelOrder.bind(this)}
            tender={this.state.currentTender}/>;

        return <div className="in-game-popup" style={{
            width: this.props.width,
            height: this.props.height,
            background: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)"
        }}>
            <div style={moveStyle}>
                <GameWindowHeader width={883} height={40} colorStart={"#FFCC33"} colorEnd={"#F2994A"}
                                  onHide={this.props.onHide} isClosable={true} title={"Тендеры"}/>
                <GameWindowBg width={883} height={340} value={content}/>
            </div>
            {this.state.isShowResearchConfirm && confirmResearchPopup}
            {this.state.isShowResearch && showResearchPopup}
            {this.state.isShowOrder && orderPopup}
        </div>
    }
}

export default TendersPanel;
